import _ from "lodash";
import client from "lib/apolloClient/client";
import {
  getQuestionLibraryFeedQuery,
  getQuestionLibraryFeedQueryV2,
  getQuestionBasicFiltersQuery,
  getQuestionTagsQuery,
  getPlannerElementSetsOfCurriculumQuery,
  getQuestionLibraryCountQuery,
  getQuestionLibraryQuestionDetailsQuery,
  getQuestionLibraryQuestionDetailsQueryV2,
  getMypPlannerElementSetsQuery,
} from "./QuestionBankQuery";
import { organizationResourceQuestionFragment } from "./QuestionBankFragment";
import { associatedEntityTypeFragmentMapping } from "./Constants";

export const getQuestionLibraryFeedFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getQuestionLibraryFeedQuery,
      variables,
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const getQuestionLibraryCountFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getQuestionLibraryCountQuery,
      variables,
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const writeQuestionLibraryFeedInCache = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getQuestionLibraryFeedQuery,
      variables,
      data,
    });
  } catch (err) {
    return {};
  }
};

export const getQuestionLibraryFeedFromCacheV2 = variables => {
  try {
    const queryData = client.readQuery({
      query: getQuestionLibraryFeedQueryV2,
      variables,
    });

    return queryData;
  } catch {
    return {};
  }
};

export const writeQuestionLibraryFeedInCacheV2 = ({ variables, data }) => {
  try {
    client.writeQuery({
      query: getQuestionLibraryFeedQueryV2,
      variables,
      data,
    });
  } catch {
    return {};
  }
};

export const getQuestionBasicFiltersFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getQuestionBasicFiltersQuery,
      variables,
    });
    return queryData;
  } catch (e) {
    return {};
  }
};

export const getQuestionTagsFromCache = variables => {
  try {
    const queryData = client.readQuery({
      query: getQuestionTagsQuery,
      variables,
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const getQuestionAssociatedEntityFromCache = (id, type) => {
  let queryData = {};
  const {
    typeName,
    fragment,
    fragmentName,
  } = associatedEntityTypeFragmentMapping[type];

  try {
    queryData = client.readFragment({
      id: `${typeName}:${id}`,
      fragment,
      fragmentName,
    });
  } catch (e) {
    return {};
  }
  if (queryData != null) return queryData;
  else return {};
};

export const getQuestionLibraryQuestionDetailsFromCache = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: getQuestionLibraryQuestionDetailsQuery,
      variables: { id },
    });

    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const writeQuestionLibraryQuestionDetailsInCache = ({ id, data }) => {
  try {
    client.writeQuery({
      query: getQuestionLibraryQuestionDetailsQuery,
      variables: { id },
      data,
    });
    return;
  } catch (e) {
    return;
  }
};

export const getPlannerElementSetsOfCurriculumFromCache = vars => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getPlannerElementSetsOfCurriculumQuery,
      variables: vars,
    });
  } catch (e) {
    return {};
  }
  return _.get(queryData, "multiNode", {});
};

export const getOrganizationResourceFromCacheV2 = id => {
  try {
    const queryData = client.readFragment({
      id: `OrganizationResource:${id}`,
      fragment: organizationResourceQuestionFragment,
      fragmentName: "organizationResourceQuestionItem",
    });

    return queryData;
  } catch (e) {
    return {};
  }
};

export const getMypPlannerElementSetsFromCache = params => {
  try {
    const queryData = client.readQuery({
      query: getMypPlannerElementSetsQuery,
      variables: params,
    });
    return _.get(queryData, "node", {});
  } catch (e) {
    return {};
  }
};

export const getQuestionLibraryQuestionDetailsFromCacheV2 = ({ id }) => {
  try {
    const queryData = client.readQuery({
      query: getQuestionLibraryQuestionDetailsQueryV2,
      variables: { id },
    });

    return _.get(queryData, "node", {});
  } catch {
    return {};
  }
};

export const writeQuestionLibraryQuestionDetailsInCacheV2 = ({ id, data }) => {
  try {
    client.writeQuery({
      query: getQuestionLibraryQuestionDetailsQueryV2,
      variables: { id },
      data,
    });
  } catch {
    return;
  }
};
